import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_USER_PRODUCT_REQUESTS = '[PRODUCT REQUESTS] GET USER PRODUCT REQUESTS'
export const GET_PRODUCT_REQUESTS_SORTED_BY_USER = '[PRODUCT REQUESTS] GET PRODUCT REQUESTS SORTED BY USER'
export const SAVE_PRODUCT_REQUEST = '[PRODUCT REQUESTS] SAVE USER PRODUCT REQUEST'
export const UPDATE_PRODUCT_REQUEST_QUANTITY = '[PRODUCT REQUESTS] UPDATE PRODUCT REQUEST QUANTITY'
export const REMOVE_PRODUCT_REQUEST = '[PRODUCT REQUESTS] REMOVE PRODUCT REQUEST'

export function getUserProductRequestsAction() {
  const request = api.get(`/product-requests/by-user`)
  return (dispatch) => {
    dispatch({ type: GET_USER_PRODUCT_REQUESTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_USER_PRODUCT_REQUESTS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_USER_PRODUCT_REQUESTS, error)
    }).finally(() => {
      dispatch({ type: GET_USER_PRODUCT_REQUESTS, payload: { loading: false } })
    })
  }
}

export function getProductRequestsSortedByUserAction() {
  const request = api.get(`/product-requests/sorted-by-user`)
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_REQUESTS_SORTED_BY_USER, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_PRODUCT_REQUESTS_SORTED_BY_USER, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_PRODUCT_REQUESTS_SORTED_BY_USER, error)
    }).finally(() => {
      dispatch({ type: GET_PRODUCT_REQUESTS_SORTED_BY_USER, payload: { loading: false } })
    })
  }
}

export function saveProductRequestAction(data) {
  const request = api.post(`/product-request/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_PRODUCT_REQUEST, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PRODUCT_REQUEST, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_PRODUCT_REQUEST, error)
    }).finally(() => {
      dispatch({ type: SAVE_PRODUCT_REQUEST, payload: { saving: false } })
    })
  }
}

export function updateProductRequestQuantityAction(productRequestId, quantity) {
  const request = api.put(`/product-request/${productRequestId}/update-quantity/${quantity}`)
  return (dispatch) => {
    dispatch({ type: UPDATE_PRODUCT_REQUEST_QUANTITY, payload: { updating_id: productRequestId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_PRODUCT_REQUEST_QUANTITY, payload: { updated_id: productRequestId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(UPDATE_PRODUCT_REQUEST_QUANTITY, error)
    }).finally(() => {
      dispatch({ type: UPDATE_PRODUCT_REQUEST_QUANTITY, payload: { updating_id: productRequestId } })
    })
  }
}

export function removeProductRequestAction(productRequestId) {
  const request = api.delete(`/product-request/remove/${productRequestId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_PRODUCT_REQUEST, payload: { removing_id: productRequestId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_PRODUCT_REQUEST, payload: { removed_id: productRequestId } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(REMOVE_PRODUCT_REQUEST, error)
    }).finally(() => {
      dispatch({ type: REMOVE_PRODUCT_REQUEST, payload: { removing_id: productRequestId } })
    })
  }
}
